export interface ProfileFact {
  label: string;
  value: string;
}

export interface TimelineItem {
  year: string;
  title: string;
  desc: string;
}

export const profile = {
  name: '吉泽明步',
  nameEn: 'Akiho Yoshizawa',
  avatar:
    'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20image%20in%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20warm%20amber%20rim%20light%2C%20elegant%20minimal%20studio%20background%2C%20soft%20grain%20texture%2C%20professional%20performing%20arts%20magazine%20cover%20photography%20with%20refined%20aesthetic&width=800&height=1000&seq=profile-main&orientation=portrait',
  tagline: '影视演员 · 作品横跨电影、电视剧与短片',
  intro:
    '吉泽明步，影视演员，作品涵盖电影、电视剧与短片等多种形式。她以克制而富有层次的表演风格受到观众关注，善于在日常化的表演中传递细腻的情绪。从治愈系剧情到悬疑类型片，她不断尝试不同类型的角色，逐渐形成了辨识度较高的银幕形象。',
  introExtra:
    '除表演工作外，她也参与部分作品的角色塑造讨论，关注剧本在现实议题上的表达。对她而言，一个角色是否值得投入，取决于故事是否足够真诚。',
  facts: [
    { label: '出生日期', value: '10 月 13 日' },
    { label: '出生地', value: '日本' },
    { label: '职业', value: '影视演员' },
    { label: '活跃年份', value: '2015 年至今' },
    { label: '作品形式', value: '电影 / 电视剧 / 短片' },
    { label: '擅长类型', value: '剧情 · 悬疑 · 文艺' },
    { label: '代表作品', value: '《遥远的星空》《时间的皱褶》《沉默的证明》' },
    { label: '常用语言', value: '日语' },
  ] as ProfileFact[],
  traits: ['克制细腻', '类型跨度广', '注重细节', '偏爱现实题材'],
  representativeIds: ['distant-stars', 'wrinkles-of-time', 'silent-proof', 'deep-sea-echo'],
  timeline: [
    { year: '2015', title: '起步阶段', desc: '以短片《风的形状》进入观众视野，开始积累影像表演经验。' },
    { year: '2017', title: '稳步成长', desc: '出演《雨中的告白》《海边旅店》，尝试不同类型的角色。' },
    { year: '2019', title: '风格确立', desc: '凭借《逆光之夏》《记忆之匙》获得更广泛的关注，表演风格逐渐清晰。' },
    { year: '2021', title: '类型拓展', desc: '在《夜幕下的她》《东京物语·新篇》中挑战调查与家庭题材。' },
    { year: '2022', title: '口碑突破', desc: '《遥远的星空》《城市之光》上映播出，作品序列进一步丰富。' },
    { year: '2023', title: '持续深耕', desc: '《沉默的证明》《时间的皱褶》相继推出，获得行业与观众认可。' },
  ] as TimelineItem[],
  stats: [
    { label: '收录作品', value: '18', unit: '部' },
    { label: '活跃年份', value: '9', unit: '年' },
    { label: '作品类型', value: '3', unit: '类' },
    { label: '代表荣誉', value: '6', unit: '项' },
  ],
};